/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const RocketIconConfig = {
  name: 'RocketIcon',
  height: 512,
  width: 512,
  svgPath: 'M505.05 19.1a15.89 15.89 0 0 0-12.2-12.2C460.65 0 435.46 0 410.36 0c-103.2 0-165.1 55.2-211.29 128H94.87A48 48 0 0 0 52 154.49l-49.42 98.8A24 24 0 0 0 24.07 288h103.77l-22.47 22.47a32 32 0 0 0 0 45.25l50.9 50.91a32 32 0 0 0 45.26 0L224 384.16V488a24 24 0 0 0 34.7 21.49l98.7-49.39a47.91 47.91 0 0 0 26.5-42.9V312.79c72.59-46.3 128-108.4 128-211.09.1-25.2.1-50.4-6.85-82.6zM384 168a40 40 0 1 1 40-40 40 40 0 0 1-40 40z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(RocketIconConfig);